import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// FR / EN picker (advertiser account language, or a new game's players language).
export function LanguageSelect({ label, hint, value, onChange, testId }) {
  const { t } = useTranslation();
  return (
    <div>
      <Label className="text-xs font-medium">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="mt-1.5 rounded-xl h-10" data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="fr" data-testid={`${testId}-fr`}>
            {t("game_editor.language_fr")}
          </SelectItem>
          <SelectItem value="en" data-testid={`${testId}-en`}>
            {t("game_editor.language_en")}
          </SelectItem>
        </SelectContent>
      </Select>
      {hint && <p className="mt-1 text-[11px] text-muted-foreground leading-snug">{hint}</p>}
    </div>
  );
}

export default LanguageSelect;
